import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { IFilterComponent, SearchFilter } from "../../../../infrastructure/iFilter-component";
import { FilterService } from "../../../../services/filter.service";
import { AuthService } from "../../../../services/auth.service";
import { FilterRecordService } from "../../../../services/filter-record.service";
import { CashDeskService } from "../../../../services/cash-desk.service";
import { PatientSearch } from "../../../../model/patient/patient-search";



@Component({
  selector: 'pending-cash-desk-filter',
  templateUrl: './pending-cash-desk-filter.component.html',
  styleUrls: ['./pending-cash-desk-filter.component.css']
})

export class PendingCashDeskFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private authService: AuthService
    , private cashDeskService: CashDeskService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      MedicalAppointmentDate: [new Date()],
      Protocol: [''],
      Patient: [null],
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    let requiredTags: string[] = [];

    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters("PendingCashDeskFilterComponent", this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters("PendingCashDeskFilterComponent", this.form);
  }

  async search(): Promise<any> {
    return await this.cashDeskService.getPatientPendingCashDeskSearchItem(this.form.controls.Protocol.value,
      this.authService.getCompanyIds(),
      (this.form.controls.Patient.value ? (<PatientSearch>this.form.controls.Patient.value).Id : null),
      (this.form.controls.MedicalAppointmentDate.value ? <Date>this.form.controls.MedicalAppointmentDate.value : null));
  }

  async ngOnInit() {

  }
}
